import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { CreditsAvailable, CreditsAvailableOverage } from './CreditsAvailable';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreditsPanelMessage = ({
  showCredits
}) => {
  const {
    availableCredits,
    hasLowCredits,
    totalOverage,
    showOverage,
    totalUsage,
    usageLimit,
    isLoading
  } = useEnrichmentCredits();
  if (!showCredits) {
    return null;
  }
  if (showOverage) {
    return /*#__PURE__*/_jsx(CreditsAvailableOverage, {
      availableCredits: availableCredits,
      hasLowCredits: hasLowCredits,
      hasOverage: totalOverage > 0,
      totalUsage: totalUsage,
      usageLimit: usageLimit
    });
  }
  return /*#__PURE__*/_jsx(CreditsAvailable, {
    availableCredits: availableCredits,
    hasLowCredits: hasLowCredits,
    isLoading: isLoading
  });
};